import type { SearchExpert } from '@bulknutrients/bulk-shared-lib/interfaces/Expert';
import { CustomImage } from '@components/Media/Image';
import { Paragraph } from '@components/Typography/Paragraph/Paragraph';
import { TextLink } from '@components/Typography/TextLink/TextLink';
import Link from 'next/link';
import type { ReactElement } from 'react';

export function SearchResultCardExpert({
  hit,
}: {
  hit: SearchExpert;
}): ReactElement {
  return hit?.slug?.length ? (
    <div className="card flex flex-col dark:bg-grey-dark overflow-hidden rounded-2xl transition-all duration-300 hover:scale-103">
      <Link
        prefetch={process.env.NEXT_PUBLIC_PREFETCH === 'true'}
        href={hit.slug}
        data-umami-event="hue-link-click"
        data-umami-event-slug={hit.slug}
        data-umami-event-location="Search Result Expert Card Image"
      >
        {typeof hit.image === 'object' && (
          <CustomImage
            image={hit.image}
            width={400}
            height={400}
            className="rounded-none"
          />
        )}
      </Link>
      <div className="p-4">
        <TextLink
          href={hit.slug}
          data-umami-event-location="Search Result Expert Card Heading"
        >
          <h2 className="font-secondary text-2xl uppercase">{hit.name}</h2>
        </TextLink>
        <Paragraph className="m-0 text-sm mt-4">
          {hit.singleLineDescription}
        </Paragraph>
      </div>
    </div>
  ) : (
    <></>
  );
}
